import { Modal } from "antd";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { MdClose, MdOutlineFileUpload } from "react-icons/md";
import { bytesToMB } from "utils/helpers/files";
import Button from "../../Components/Button";
import Header from "../../Components/Header";
import Input from "../../Components/Input";
import { COLORS } from "shared/style/colors";

const DocumentUpload = ({
  items,
  label,
  onDownload,
  onUpload,
  onFileRemove,
  error,
  info,
  required = false,
  hint,
  childrenCheckbox,
  onChildrenCheckboxChange,
  childrenCheckboxChecked,
}) => {
  const [infoVisible, setInfoVisible] = useState(false);

  return !isEmpty(items) ? (
    <div className="miltis__document-upload">
      <div className="miltis__document-upload--file">
        {items.map((item, index) => (
          <div key={index} className="miltis__document-upload--file-item">
            <div className="miltis__document-upload--file-content">
              <div className="miltis__document-upload--file-name">
                {item?.name || ""}
              </div>
              <div className="miltis__document-upload--file-size">
                {(() => {
                  const fileName = get(item, "name", "");
                  const extension =
                    fileName.split(".").pop()?.toLowerCase() || "";
                  const fileSize = item?.size ? bytesToMB(item?.size) : "";
                  return extension
                    ? `.${extension} ${
                        fileSize ? `| ${fileSize.replace(".", ",")} MB` : ""
                      }`
                    : fileSize
                      ? `${fileSize.replace(".", ",")} MB`
                      : "";
                })()}
              </div>
            </div>
            <button
              type="button"
              className="miltis__document-upload--file-remove-button"
              onClick={() => onFileRemove(item)}
            >
              <MdClose size={20} color={COLORS.C_WHITE} />
            </button>
          </div>
        ))}
      </div>
      {error && <span className="miltis__document-upload--error">{error}</span>}
    </div>
  ) : (
    <>
      <div className="miltis__document-upload--container">
        <div className="miltis__document-upload--content">
          <div className="miltis__document-upload--label-wrapper">
            <div className="miltis__document-upload--label">
              <span className="miltis__document-upload--label-text">
                {label}
              </span>
              {required && (
                <span className="miltis__document-upload--required">
                  Obligatoire
                </span>
              )}
            </div>
            {hint && <p className="miltis__document-upload--hint">{hint}</p>}
          </div>
          <Input
            type="file"
            variant="uploader"
            showUploadList={false}
            fileList={items || []}
            onUpload={onUpload}
            className="miltis__document-upload--input"
          >
            <div className="miltis__document-upload--button-wrapper">
              <div className="miltis__document-upload--button">
                <MdOutlineFileUpload size={20} color={COLORS.C_WHITE} />
              </div>
            </div>
          </Input>
        </div>
      </div>

      {error && <span className="miltis__document-upload--error">{error}</span>}
      <Modal
        centered
        open={infoVisible}
        onCancel={() => setInfoVisible(false)}
        width={500}
        footer={null}
      >
        <div className="mutualMobility-help__modal">
          <Header small subtitle={"Á savoir"} title="" content={info} />
          <Button
            width={"100%"}
            type={"primary-outlined"}
            onClick={() => setInfoVisible(false)}
            className="mt-24"
          >
            <MdClose /> Fermer
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DocumentUpload;
